import React from 'react'
import { Container, FlexColumn, FlexRow } from 'components/common/Containers'
import { Button } from 'components/common/Buttons/Button'
import { useRouter } from 'next/router'
import { RouteEnum } from 'enums/RouteEnum'
import { H2 } from 'components/common/Texts/H2/H2'
import styles from './TryNow.module.scss'

interface Props {
  toolName: string
  title?: string
  description?: React.ReactNode
  ctaText?: string
  onClickCta?: () => void
}

const TryNow: React.FC<Props> = ({
  toolName,
  title,
  description,
  ctaText,
  onClickCta,
}) => {
  const router = useRouter()

  const handleSignUp = () => {
    router.push(`${RouteEnum.SIGNUP}/?from=${router.pathname}`)
  }

  return (
    <Container>
      <section className={styles.section}>
        <FlexRow align="center" justify="space-between" wrap="wrap" gap="1rem">
          <FlexColumn align="flex-start" gap="20px">
            <H2 className={styles.title}>
              {title ? title : 'Try Bishopi Now'}
            </H2>

            <p className={styles.description}>
              {description ? (
                description
              ) : (
                <span>
                  Start using the full version of Bishopi’s <b>{toolName} </b>
                  today!
                </span>
              )}
            </p>
          </FlexColumn>

          <Button size="lg" onClick={onClickCta ? onClickCta : handleSignUp}>
            {ctaText ? ctaText : 'Sign up for Bishopi'}
          </Button>
        </FlexRow>
      </section>
    </Container>
  )
}

export default TryNow
